import { objectWithoutProperties as _objectWithoutProperties, extends as _extends, objectSpread2 as _objectSpread2 } from '../_virtual/_rollupPluginBabelHelpers.js';
import _styled from '@emotion/styled/base';
import React__default from 'react';
import Tooltip from '@mui/material/Tooltip';
import isStyledPropsValid from '../utils/isStyledPropsValid.js';

var _excluded = ["className"];
var StyledIconTooltip = /*#__PURE__*/_styled(function (_ref) {
  var className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React__default.createElement(Tooltip, _extends({}, props, {
    classes: {
      tooltip: 'tooltip-content',
      popper: className
    }
  }));
}, {
  shouldForwardProp: isStyledPropsValid,
  target: "e10qujoi3"
} )(function (_ref2) {
  var theme = _ref2.theme,
    withoutMaxWidth = _ref2.withoutMaxWidth,
    iconSize = _ref2.iconSize;
  return {
    '&[data-popper-placement*="top"]': {
      '& .MuiTooltip-tooltip.tooltip-content': {
        marginBottom: iconSize ? "-".concat(iconSize * 0.4, "px") : '0px',
        marginLeft: iconSize ? "".concat(iconSize * 1.25, "px") : '15px'
      }
    },
    '& .tooltip-content': _objectSpread2({
      margin: theme.spacing(1.5, 0),
      padding: '8px',
      fontSize: theme.fontSize.TINY,
      color: theme.customColors.grey[600],
      backgroundColor: theme.customColors.white,
      borderRadius: '3px',
      maxWidth: '280px',
      fontWeight: 'regular',
      border: "1px solid ".concat(theme.customColors.grey[400])
    }, withoutMaxWidth && {
      maxWidth: 'initial'
    })
  };
}, "" );
var StyledIconWrap = /*#__PURE__*/_styled('span', {
  shouldForwardProp: isStyledPropsValid,
  target: "e10qujoi2"
} )(function (_ref3) {
  var theme = _ref3.theme,
    size = _ref3.size,
    color = _ref3.color;
  return {
    fontSize: "".concat(size, "px"),
    display: 'inline-flex',
    verticalAlign: 'top',
    color: theme.palette[color].main
  };
}, "" );
var StyledIconToolTipContentHeader = /*#__PURE__*/_styled('div', {
  shouldForwardProp: isStyledPropsValid,
  target: "e10qujoi1"
} )(function (_ref4) {
  var theme = _ref4.theme;
  return {
    overflow: 'hidden',
    fontSize: theme.fontSizeNormal,
    fontWeight: 'bold',
    marginBottom: theme.spacing(1),
    display: '-webkit-box',
    '-webkit-box-orient': 'vertical',
    '-webkit-line-clamp': 2,
    wordBreak: 'normal'
  };
}, "" );
var StyledIconToolTipContentLink = /*#__PURE__*/_styled('div', {
  shouldForwardProp: isStyledPropsValid,
  target: "e10qujoi0"
} )(function (_ref5) {
  var theme = _ref5.theme;
  return {
    marginTop: theme.spacing(1),
    '& a:visited, & a:link': {
      color: theme.customColors.secondary,
      textDecoration: 'none'
    }
  };
}, "" );

export { StyledIconToolTipContentHeader, StyledIconToolTipContentLink, StyledIconTooltip, StyledIconWrap };
